import React from 'react'
import EquipmentCard from './EquipmentCard'

function EquipmentmobCard({ data, getData }) {
  if (!Array.isArray(data) || data.length === 0) {
    return <p className="text-center text-gray-500 mt-4">No equipment found</p>;
  }

  return (
    <div className="w-full h-[calc(100vh-199px)] overflow-y-auto py-1 px-2">
      {data.map((item, index) => (
        <EquipmentCard item={item} getData={getData} key={item.id || index} />
      ))}
    </div>
  );
}


export default EquipmentmobCard
